import type { ApiResponse, FeaturePayload } from '@/store/types'
import { get } from '@/backend/api'
import type { ParsedError } from '@/backend/error'
import { errorMessages, isErrorResponse, parseError } from '@/backend/error'

export const loadFeatures = async (): Promise<ApiResponse<FeaturePayload[]> | ParsedError> => {
  try {
    const response = await get<FeaturePayload[]>('features')
    return response
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }
    return parseError(error, errorMessages.GET_FEATURES)
  }
}
